import React from 'react';

import { formatDate } from 'lib/helpers/dateUtils';
import useTimezone from 'lib/hooks/useTimezone';

import Avatar from 'components/shared/Avatar/Avatar';
import Typography from 'components/shared/Typography/Typography';

import { ACTION_MAP } from '../lib/constants';

import ActivityContent from './ActivityContent';

const ActivityLog = ({ category, activity, overwriteActivities }) => {
  const timezone = useTimezone();

  const {
    creator,
    created_at,
    prefix = '',
    formattedChanges,
    action,
    isNestedCreate,
    isCreateRecord
  } = activity;

  const fullName = creator ? `${creator.f_name} ${creator.l_name}` : 'Unknown';

  const authorInfoElement = (
    <div className="flex flex-wrap gap-1">
      <Typography
        variant="p"
        weight="600"
        size="xs"
        color="neutral-800"
        className="whitespace-nowrap">
        {fullName}
      </Typography>

      <div className="flex items-center">
        <Typography variant="p" size="xs" className="gap-1" color="neutral-700">
          {ACTION_MAP[isNestedCreate ? 'create' : action]}
          {isCreateRecord ? (
            <span>
              this <span className="font-medium">{category || 'record'}</span>{' '}
            </span>
          ) : (
            ''
          )}
        </Typography>

        <Typography
          variant="p"
          weight="600"
          size="xs"
          color="neutral-800"
          className="whitespace-nowrap">
          {prefix ? `\u00A0${prefix}` : isCreateRecord ? '' : ':'}
        </Typography>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between gap-2">
        <div className="flex items-center gap-1">
          <Avatar
            size="small"
            className="mt-[2px]"
            id={creator?.id}
            fullName={fullName}
            image={creator?.profile_photo}
          />
          {authorInfoElement}
        </div>
        <Typography color="neutral-500" size="xs" weight="medium" className="whitespace-nowrap">
          {formatDate(created_at, timezone, 'h:mm a')}
        </Typography>
      </div>

      {!isCreateRecord && (
        <ActivityContent
          overwriteActivities={overwriteActivities}
          formattedChanges={formattedChanges}
          action={action}
        />
      )}
    </div>
  );
};

export default ActivityLog;
